import React, { useState } from 'react'
import wallpaper from '../img/bg-1.jpeg'
import { useNavigate } from "react-router-dom";
import '../index.css'

const LockScreen = () => {
    const [password, setPassword] = useState()
    const navigate = useNavigate();

    const handleChange = (e)=>{
        setPassword(e.target.value)
        console.log(typeof password)
    }

    const login = () =>{
        if(password === '12345'){
            navigate('/screen')
        }
        else{
          alert('Please Enter Correct Password')
        }
    }


  return (
    <div className='overflow-hidden relative'>
      <img className='w-[100vw] h-[100vh] object-cover' src={wallpaper} alt="lockscreen" />
      <div className='w-[100vw] h-[100vh] absolute bg-transparent backdrop-blur-md z-10 top-0 left-0 right-0 bottom-0'/>

      <div className='details absolute top-[40%] left-[50%] -translate-x-[50%] -translate-y-[50%] z-10 flex flex-col items-center space-y-3'>
        <span className='text-gray-500 text-6xl bg-white rounded-full w-32 h-32 flex justify-center items-center'><i className="fa-regular fa-user"></i></span>
        <span className='text-4xl text-white'>User</span>
        <div className='overflow-hidden flex max-w-60'>
            <input onChange={handleChange} className='py-1 px-2 outline-none ' type="password" />
            <button onClick={login} className='bg-blue-600 py-1 px-2 text-white'><i className="fa-solid fa-arrow-right"></i></button>
        </div>
        <span className='text-white text-sm cursor-pointer'>Forgot Password</span>
        <span className='text-white text-sm cursor-pointer'>Password is 12345</span>
      </div>

      <div className='bottom absolute bottom-0 z-10 flex items-center w-full justify-between p-5'>
        <div className='left flex items-center space-x-3'>
            <span className='text-gray-500 text-2xl bg-white rounded-full w-10 h-10 flex justify-center items-center cursor-pointer'><i className="fa-regular fa-user"></i></span>
            <span className='text-white'>User</span>
        </div>
        <div className='right space-x-3'>
            <span className='text-white text-xl cursor-pointer hover:bg-white/50 p-2 rounded-sm'><i className="fa-solid fa-wifi"></i></span>
            <span className='text-white text-xl cursor-pointer hover:bg-white/50 p-2 rounded-sm'><i className="fa-solid fa-power-off"></i></span>
        </div>
      </div>

    </div>
  )
}

export default LockScreen
